import { DealerLastUpdatedActionTypes } from "./actionTypes";

export interface DealerLastUpdatedItem {
    id: number;
    dealerId: string;
    lastUpdate: string;
    jobNumber: string;
    jobId: number;
    creationTime: string;
    dealerName: string;
}

export interface DealerLastUpdatedInitialState {
    loading: boolean;
    error: string;
    message: string;
    dealerLastUpdatedList: {
        values: DealerLastUpdatedItem[];
        totalRecords: number;
    };
    dealerDropdownList: any[];
    paginatorCount: number;
    employeeDropdownList: any[];
    manufacturerDropdownList: any[];
}

const INITIAL_STATE: DealerLastUpdatedInitialState = {
    loading: false,
    error: "",
    message: "",
    dealerLastUpdatedList: {
        values: [],
        totalRecords: 0,
    },
    dealerDropdownList: [],
    paginatorCount: 0,
    employeeDropdownList: [],
    manufacturerDropdownList: [],
};

const DealerLastUpdatedReducer = (state = INITIAL_STATE, action: any) => {
    const { type, payload } = action;

    switch (type) {
        // Loading states
        case DealerLastUpdatedActionTypes.GET_DEALER_LAST_UPDATED_LIST:
            return {
                ...state,
                loading: true,
                paginatorCount: 0,
            };

        case DealerLastUpdatedActionTypes.GET_DEALER_DROPDOWN_LIST:
            return {
                ...state,
                loading: true,
            };

        case DealerLastUpdatedActionTypes.GET_MANUFACTURER_DROPDOWN_LIST:
            return {
                ...state,
                loading: true,
            };

        // Success states
        case DealerLastUpdatedActionTypes.GET_DEALER_LAST_UPDATED_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                dealerLastUpdatedList: {
                    values: payload.data.items,
                    totalRecords: payload.data.totalCount,
                },
                paginatorCount: payload.data.items.length,
            };

        case DealerLastUpdatedActionTypes.GET_DEALER_DROPDOWN_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                dealerDropdownList: payload.data.filter((item: any) => item.isDeleted !== true),
            };

        case DealerLastUpdatedActionTypes.GET_EMPLOYEE_DROPDOWN_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                employeeDropdownList: payload.data.filter((item: any) => item.isDeleted !== true),
            };

        case DealerLastUpdatedActionTypes.GET_MANUFACTURER_DROPDOWN_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                manufacturerDropdownList: payload.data.filter((item: any) => item.isDeleted !== true),
            };

        // Error states
        case DealerLastUpdatedActionTypes.GET_DEALER_LAST_UPDATED_LIST_FAIL:
        case DealerLastUpdatedActionTypes.GET_DEALER_DROPDOWN_LIST_FAIL:
        case DealerLastUpdatedActionTypes.GET_MANUFACTURER_DROPDOWN_LIST_FAIL:
            return {
                ...state,
                loading: false,
                error: payload,
            };

        // Clear states
        case DealerLastUpdatedActionTypes.CLEAR_DEALER_LAST_UPDATED_DATA:
            return {
                ...state,
                loading: false,
                error: "",
                message: "",
                dealerLastUpdatedList: {
                    values: [],
                    totalRecords: 0,
                },
            };

        case DealerLastUpdatedActionTypes.CLEAR_DEALER_LAST_UPDATED_MESSAGE:
            return {
                ...state,
                message: "",
                error: "",
                loading: false,
            };

        default:
            return state;
    }
};

export default DealerLastUpdatedReducer;
